// extracted by mini-css-extract-plugin
export const title = "sticky-title-module--title--3xeK3";
export const scrollingDown = "sticky-title-module--scrollingDown--1NMwm";